<template>
    <div>
        <!-- Shop -->
        <div class="container">
            <div class="pt-5 pb-5 d-flex align-items-center justify-content-between">
                <h1 class="m-0 flex-grow-1 mr-auto">Winkelen</h1>
                <form class="d-flex" @submit.prevent="onSearchFormSubmit">
                    <input
                        type="text"
                        class="form-control d-inline-block"
                        placeholder="Zoeken...."
                        v-model="searchQuery"
                        style="width: auto;"
                    />
                    <button
                        class="btn btn--accent"
                        type="submit"
                    >
                        <i class="fa fa-search mx-1"></i>
                    </button>
                </form>
                <button
                    class="btn btn--subtle d-inline-block d-md-none"
                    @click.prevent="showCategories = true"
                    v-if="!showCategories"
                >
                    <i class="fa fa-filter mr-1"></i> Filteren
                </button>
            </div>

            <div class="row pb-5">
                <div class="col-lg-3 col-md-4">
                    <!-- Sidebar -->
                    <sidebar v-if="showCategories"></sidebar>
                    <!-- End Sidebar -->
                </div>
                <div class="col-lg-9 col-md-8">
                    <!-- Catalog -->
                    <loader v-if="products == null"></loader>
                    <div
                        class="message warning"
                        v-if="products && visibleProducts.length == 0"
                    >Geen producten gevonden die voldoen aan uw criterea.</div>
                    <!-- Category Description -->
                    <div
                        class="panel"
                        v-if="category && category.description"
                        v-html="category.description"
                    ></div>
                    <!-- End Category Description -->
                    <div class="row">
                        <div
                            class="col-lg-4 col-sm-6 mb-30"
                            v-for="product in visibleProducts"
                            :key="product.id"
                        >
                            <!-- Product -->
                            <product :product="product"></product>
                            <!-- End Product -->
                        </div>
                    </div>
                    <!-- End Catalog -->
                </div>
            </div>
        </div>
        <!-- End Shop -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            products: null,
            visibleProducts: [],
            showCategories: true,
            searchQuery: ""
        };
    },
    computed: {
        category() {
            if (this.$route.params.category) {
                return this.$store.getters.categoryBySlug(
                    this.$route.params.category
                );
            }
        },
    },
    mounted() {
        if (window.innerWidth < 767.98) {
            this.showCategories = false;
        }
        if (this.$route.params.category) {
            this.getCategory();
        } else {
            this.getProducts();
        }
    },
    methods: {
        getProducts() {
            this.$http
                .get("/products")
                .then(res => {
                    this.products = res.data.data;

                    this.renderVisibleProducts()
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getCategory() {
            this.$http
                .get("/categories/" + this.$route.params.category + "/products")
                .then(res => {
                    this.products = res.data.data;

                    this.renderVisibleProducts()
                })
                .catch(err => {
                    console.log(err);
                });
        },

        renderVisibleProducts() {
            this.visibleProducts = this.products.filter(product => {
                if (this.searchQuery.length == 0) {
                    return true
                }

                return (
                    product.title
                        .toLowerCase()
                        .indexOf(this.searchQuery.toLowerCase()) != -1
                );
            });
        },

        onSearchFormSubmit() {
            if (['transport', 'transportaanvraag'].includes(this.searchQuery.toLowerCase())) {
                this.$router.push('/transport-aanvraag')
                return
            }
            
            this.renderVisibleProducts()
        }
    }
};
</script>
